export const TenantKey = 'companyId'
export const UniqueKey = 'id'
